import React from 'react';
import { siteData } from '../mock';

const Hero = () => {
  return (
    <section id="hero" className="hero-section relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Grain Effect */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1662591231342-c535008f927f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHx1cmJhbiUyMGdydW5nZXxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3NzMyMDE3NzR8MA&ixlib=rb-4.1.0&q=85')`
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-70"></div>
        <div className="grain-overlay"></div>
      </div>

      {/* Pink Gradient Accent */}
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-pink-accent opacity-20 blur-[120px] pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-pink-accent opacity-15 blur-[100px] pointer-events-none"></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 lg:px-8 text-center">
        <h1 className="hero-brand-text mb-8 animate-fade-in">
          {siteData.brand}
        </h1>
        <p className="hero-tagline text-lg lg:text-2xl max-w-3xl mx-auto animate-fade-in-up opacity-80">
          {siteData.tagline}
        </p>
        
        <div className="mt-12 flex flex-wrap items-center justify-center gap-4 animate-fade-in-up">
          <a 
            href="#portfolio" 
            className="cta-button large bg-white text-black border-white hover:bg-opacity-90"
          >
            View Work
          </a>
          <a 
            href="#contact" 
            className="cta-button large bg-transparent text-white border-white hover:bg-white hover:text-black"
          >
            Get in Touch
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white border-opacity-50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-pink-accent rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
